import React , { useState , useEffect , useRef, useLayoutEffect} from 'react'

import  {FloatingLabel,Form , Row , Col, Button ,  } from 'react-bootstrap';

import Select from 'react-select'

import { ApiCallGet } from '../ApiCall/ApiCall';
import ConfiguradorCuentas from './ConfiguradorCuentas';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faAdd, faPlus } from '@fortawesome/free-solid-svg-icons'

var uniqid = require('uniqid');

export default function CofiguradorForm() {


    const [fullCodigo,setFullCodigo] = useState(  )
    const [options,setOptions] = useState([]) ;
    //const [cuentas,setCuentas] = useState([<ConfiguradorCuentas setValue={setValue} index={uniqid} erase={onEraseCuenta}/>]) ; // Arreglo de las cuentas

    var uid = uniqid() ;

    const [cuentas,setCuentas] = useState(
        [
            {
                uniqueid : uid ,
                elem :<ConfiguradorCuentas setValue={setValue} index={uid} erase={onEraseCuenta}/>
            }
        ] 

    )
        //[<ConfiguradorCuentas setValue={setValue} index={uniqid} erase={onEraseCuenta}/>]) ; // Arreglo de las cuentas

    const [cuenValues,setCuenValues] = useState([])


    const [values,setValues] = useState( null )

    
    


    

    const refNombre = useRef() ;
    const refBusqueda = useRef() ;
    const refComentario = useRef() ;
    const refBuscar = useRef() ;


    var isLoading = false ;


    function setValue( val )
    {
        console.log( "Nos llega un setValue " , val )

        setValues( val )
    }


    useEffect(() =>{

        console.log( "useEffect cuentas = " , cuentas )

    } , [cuentas])


    /*
    const removeFields = (index) => {

        if( inputFields.length === 1 )
        {
            return ;
        }

        let data = [...inputFields];
        data.splice(index, 1)
        setInputFields(data)
    }

    /////////// Para agregar ///////////////
    setInputFields([...inputFields, newfield])

    */


    function onEraseCuenta( uniqid )
    {
        console.log( "onEraseCuenta ... " + uniqid ) ;


        console.log( "Cuentas = " , cuentas ) ;


        if( cuentas.length === 1 )
        {
            console.log( "Longitud = 1")
            return ;
        }

        let data = [...cuentas];

        console.log( "Antes de borrar " + uniqid , data )

        var id = 0 ;



        for( var i = 0 ; i < cuentas.length ; i++ )
        {

            if ( cuentas[i].uniqueid === uniqid )
            {
                id = i ;


                break ;

            }

        }


        data.splice(id, 1)


        console.log( "Despues de borrar " + uniqid , data )
        setCuentas(data)


        // var myCuentas = [...cuentas]

        // console.log( "myLong = " + myCuentas.length ) ;

        // var theCuentas = []

        // for( var i = 0 ; i < cuentas.length ; i++ )  // 0 , 1 , 2 => 0, 1
        // {
        //     console.log( "Index = " + i ) ; 
        //     if ( i !== index )
        //     {
        //         console.log( "Agregando " + i ) ;
        //         theCuentas.push( cuentas[i] )
        //     }
            
        // }

        // setCuentas( theCuentas ) ;
    }


    function onAddCuenta(e)
    {

        var index = cuentas.length ;


        console.log( "Agregando configurador " + index)

        var obj ={
            index : index
        }

        var uid = uniqid() ;

        setCuentas( [...cuentas,{
            uniqueid : uid ,
            elem : <ConfiguradorCuentas index={uid} erase={onEraseCuenta}/>
        } ] )

        //setCuentas([...cuentas,<ConfiguradorCuentas index={theIndex} erase={onEraseCuenta}></ConfiguradorCuentas>])

        // e.preventDefault() ;

        // console.log( "addCuentas " + cuentas.length  +  " ====>  " + typeof(cuentas))

        // var theCuentas = [...cuentas] ;

        // var theIndex = theCuentas.length ;

        // theCuentas.push( <ConfiguradorCuentas index={theIndex} erase={onEraseCuenta}></ConfiguradorCuentas>)

        // console.log( "Cuentas.lenght = " + cuentas.length ) ;

        // console.log( "Al agregar long = " + theCuentas.length )

        // setCuentas( theCuentas  )

        
        //newState.push(newItem);

        //setCuentas( [...cuentas,<ConfiguradorCuentas></ConfiguradorCuentas>])
    }


    function onBuscar()
    {
        var theBusqueda = refBusqueda.current.value ;

        theBusqueda = theBusqueda.trim() ;

        if ( theBusqueda.length > 3 )
        {
            console.log( " Nos vamos a la busqueda")

            var parms = ""


            parms = theBusqueda.split( " ") ;


            ApiCallGet( "getprodserv/?parms=" + parms)
            .then((response) => {

                console.log( "response = " + JSON.stringify(response) ) ;


                //"c_claveProdServ":"10101501","palabras":null,"descripcion":"Gatos vivos"},

                var theOptions = []

                for( var i = 0 ; i < response.length ; i++ )
                {
                    var option = {}

                    option.value = response[i].c_claveProdServ ;
                    option.label = response[i].c_claveProdServ  + " - " + response[i].descripcion ;


                    theOptions.push( option ) ;

                }

                setOptions( theOptions )

            })
            .catch((err) => {


                console.log( err ) ;

            })


        }
    }

    useEffect(() => {


        console.log( "Cargando pagina ...............")


        if ( isLoading === true  )
        {
            return ;
        }

        isLoading = true ;


        if ( cuentas.length === 0 ) // Nunca va a ser cer , hay qye quitar esta funcion
        {
            console.log( "Agregando configuradorCuentas")
            //cuentas.push( <ConfiguradorCuentas></ConfiguradorCuentas>)

            var arr = [<ConfiguradorCuentas index={0} erase={onEraseCuenta}></ConfiguradorCuentas> ]

            //setCuentas( arr ) // Sam
        }

        // ApiCallGet("claveproductoservicio")
        // .then((response) => {

        //     console.log( JSON.stringify( response ) )

        //     setFullCodigo( response ) ;

        //     for( var i = 0 ; i < 200 ; i++ )
        //     {
        //         var option = {}

        //         option.value = response[i].id_claveprodserv.toString() ;
        //         option.label =   response[i].c_ClaveProdServ + " => " +  response[i].descripcion ;

        //         options.push( option ) ; 
        //     }

        //     setOptions( options ) ;

        // })
        // .catch((err) => {
        //     console.log( err ) ;
        // })

    } , [])



    useEffect(() => {

        console.log( "************* cambio de options")

    } ,[options])


    function handleSubmit(e)
    {
        console.log( "HandleSubmit") ;
    }

  return (
    <Form  onSubmit={handleSubmit} style={{color:'black'}}>


        <Row style={{marginLeft:'10px', marginRight:'10px'  }}>

            <Col className='col-6'>


                <FloatingLabel
                controlId="nombre"
                label="Nombre"
                className="mb-1 " 
                >
                <Form.Control ref={refNombre}  
                    type="text" placeholder="Nombre" size='sm' />
                </FloatingLabel>




            </Col>
            <Col className='col-6'>


                <FloatingLabel controlId="comentario" label="Comentario" >
                    <Form.Control ref={refComentario} type="text" placeholder="Comentario" size='sm' style={{ height: '10px' }} />
                </FloatingLabel>


            </Col>




        </Row>



        <Row style={{marginLeft:'10px', marginRight:'10px' , marginTop : '10px'}}>


            <Col className='col-4'>

                
                <FloatingLabel controlId="comentario" label="Busqueda Clave Prod Serv" >
                    <Form.Control ref={refBusqueda} type="text" placeholder="Busqueda" title='Busqueda de Clave Producto Servicio' 
                        size='sm' style={{ height: '10px' }} />
                </FloatingLabel>


            </Col>


            <Col className='col-2' style={{fontSize:'10px'}}>
                <Button  onClick={onBuscar} ref={refBuscar}
                    className="form-control">Buscar</Button>
            </Col>


            <Col className='col-6' style={{zIndex:5}}>

                <Select options={options} isMulti>

                </Select>
            </Col>

        <hr className='mt-3'/>

        <Row>

            <Col className='col-2'> 
                <p>Cuentas</p>
            </Col>

            <Col className='col-2'> 
            <FontAwesomeIcon  title='Agrega Cuenta' onClick={onAddCuenta} icon={faAdd}></FontAwesomeIcon>
            </Col>



        </Row>

       


        </Row>


        {
            cuentas.length > 0 && (
                cuentas.map( (item ,index ) => (

                    
                
                    item.elem

                    
                ))
            )


            // cuentas.length > 0 && (
            // cuentas.map((item , index ) => (
            //      item 
            //  ))
        }
{/*<ConfiguradorCuentas index={index} erase={onEraseCuenta}></ConfiguradorCuentas> */}
        {/* <ConfiguradorCuentas></ConfiguradorCuentas> */}

        

        <Row style={{marginLeft:'10px', marginRight:'10px'}}>
            <Col className='col-2 mt-2'>

                <Button  type="submit"  
                        className="form-control">Grabar</Button>
            </Col>


        </Row>

        




    </Form>

    
  )
}
